import { createFormState, required, isProbablyEmail } from 'redux-freeform';

const formConfig = {
  email: {
    validators: [required(), isProbablyEmail()],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);
